import { render, staticRenderFns } from "./appendix.vue?vue&type=template&id=5aea052c"
import script from "./appendix.vue?vue&type=script&lang=js"
export * from "./appendix.vue?vue&type=script&lang=js"
import style0 from "./appendix.vue?vue&type=style&index=0&id=5aea052c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports